__turbopack_context__.v({
  "emptyListBodyText": "Bd8vua_emptyListBodyText",
  "emptyListSubHeading": "Bd8vua_emptyListSubHeading",
  "emptyListTitleContainer": "Bd8vua_emptyListTitleContainer",
  "emptyProductList": "Bd8vua_emptyProductList",
  "listItem": "Bd8vua_listItem",
  "loaderWrapper": "Bd8vua_loaderWrapper",
});
